module.exports = __webpack_public_path__ + "media/images/icon-construction-1de182c986da6bd8ed2d00790149a521.svg";